angular.module('impactx.catalog').directive('ixCatalogContracts', function() {
    return {
        scope: {
            contracts: "=",
            contractNoLabel: "=",
            priceGroupLabel: "=",
            buyerComLabel: "=",
            buyerContactLabel: "=",
            contractNameLabel: "=",
            contractTypeLabel: "=",
            startDateLabel: "=",
            endDateLabel: "=",
            contractLinkTooltip: "=",
            jumpToContractFunction: "&"
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/catalogcontracts.tmpl.html'
    };
});